import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_WEATHERS_SUCCESS = 'GET_PROJECT_WEATHERS_SUCCESS'
export const GET_PROJECT_WEATHERS_FAILURE = 'GET_PROJECT_WEATHERS_FAILURE'

// -- CREATE
export const CREATE_PROJECT_WEATHER_SUCCESS = 'CREATE_PROJECT_WEATHER_SUCCESS'
export const CREATE_PROJECT_WEATHER_FAILURE = 'CREATE_PROJECT_WEATHER_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_WEATHER_SUCCESS = 'UPDATE_PROJECT_WEATHER_SUCCESS'
export const UPDATE_PROJECT_WEATHER_FAILURE = 'UPDATE_PROJECT_WEATHER_FAILURE'

// -- DELETE
export const DELETE_PROJECT_WEATHER_SUCCESS = 'DELETE_PROJECT_WEATHER_SUCCESS'
export const DELETE_PROJECT_WEATHER_FAILURE = 'DELETE_PROJECT_WEATHER_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_WEATHERS = 'SEARCH_PROJECT_WEATHERS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project's weather attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project weather.
 * @returns {Promise<array<object>>}
 */
export const searchProjectWeathers = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_WEATHERS,
    data: terms
  })
}

/**
 * GET the list of all the weathers that belong to a specific project.
 *
 * @param {uuid} pid Project ID.
 * @returns {Promise<array<object>>}
 */
export const getProjectWeathers = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_WEATHER_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.getProjectWeathers()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_WEATHERS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_WEATHERS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a project weather.
 *
 * @param {object} newWeather New weather to be created.
 * @param {uuid} pid Project ID.
 * @returns {object}
 */
export const createProjectWeather = (newWeather, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_WEATHER_CREATE, { pid })
  const api = new Api(path)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  const result = await api.create(newWeather, config)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.createWeather()', { path, newWeather, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_WEATHER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_WEATHER_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project weather attribute.
 *
 * @param {object} newWeather Weather object that will replace the previous one.
 * @param {uuid} wid Project weather ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const updateProjectWeather = (newWeather, wid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_WEATHER_UPDATE, { pid, wid })
  const api = new Api(path)
  const result = await api.update(newWeather)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.updateProjectWeather()', {
    newWeather,
    path,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_WEATHER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_WEATHER_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project weather.
 *
 * @param {uuid} wid Project weather ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const deleteProjectWeather = (wid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_WEATHER_DELETE, { pid, wid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.deleteProjectWeather()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_WEATHER_SUCCESS,
      data: wid
    })
  }

  return dispatch({
    type: DELETE_PROJECT_WEATHER_FAILURE,
    data: result.data
  })
}
